// extracted by mini-css-extract-plugin
export default {"toast":"wwFhJp+kCe9OgquJyc0mlg==","text":"p85YUAp4aJShF1jDgquxSw==","icon-container":"A41LXqnhxlX9G9ixHHD04g==","close":"SYKsKZqaEptpKXuhvWWO-w==","error":"k1HI94vICIH0HHclSiEQ-w=="};